import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { UsersTable } from '~/components/settings/masterData/users/UsersTable';

import { routeParams, validateSearch } from './-routeParams';

export const Route = createFileRoute('/(main)/settings/masterdata/users/')({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/masterdata/users',
    ...routeParams,
  }),
  component: UsersTable,
  validateSearch,
});

export const MASTERDATA_USERS = buildRouteExport({ Route, ...routeParams });
